import request from '@/utils/request'


/**
 *  方案列表
 * @param param
 */
export function getProgramList(type,query) {
    return request({
        url: '/api/scheme/list/' + type,
        method: 'post',
        data: query || {}
    })
}

/**
 * 根据type值查询所有方案
 * @param param
 */
export function findSchemeList(type) {
    return request({
        url: '/api/scheme/all/' + type,
        method: 'post'
    })
}

/**
 *  分页查询个人方案
 * @param param
 */
export function findPersonList(query) {
    return request({
        url: '/api/scheme/list/person',
        method: 'post',
        data: query || {}
    })
}

/**
 * 新增个人方案
 * @param param
 */
export function insertPerson(query) {
    return request({
        url: '/api/scheme/save/person',
        method: 'post',
        data: query
    })
}

/**
 *  获取单个方案
 * @param param
 */
export function getOneProgram(sId) {
    return request({
        url: '/api/scheme/get/' + sId,
        method: 'get'
    })
}
/**
 *  获取单个方案，返回dto
 * @param param
 */
export function getDetail(sId) {
    return request({
        url: '/api/scheme/view/' + sId,
        method: 'get'
    })
}

/**
 *  查询所有方案
 * @param param
 */
export function findAllScheme(companyId) {
    return request({
        url: `/api/scheme/${companyId}/list`,
        method: 'get'
    })
}



/**
 *  添加方案
 * @param param
 */
export function addProgram(query) {
    return request({
        url: '/api/scheme/save',
        method: 'post',
        data: query
    })
}

/**
 *  修改方案
 * @param param
 */
export function editProgram(query) {
    return request({
        url: '/api/scheme/update',
        method: 'post',
        data: query
    })
}


/**
 *  删除修方案
 * @param param
 */
export function deleteProgram(sId) {
    return request({
        url: '/api/scheme/delete/' + sId,
        method: 'get'
    })
}

/**
 *  查询当前公司下的所有方案
 * @param param
 */
export function findSchemeByUserId(userId) {
    return request({
        url: '/api/scheme/' + userId + '/list',
        method: 'get'
    })
}

/**
 *  获取公司下方案购买总数
 * @param param
 */
export function getAmmout(companyId, schemeId) {
    return request({
        url: '/api/scheme/ammount' + companyId + schemeId,
        method: 'get'
    })
}
